<template>
    <div class="planilha">
        <div class="card">
            <div class="card-body" style="display: block; z-index: 10000;">
                <div class="kpi-grid">
                    <div class="kpi-card">
                        <div class="kpi-header">
                            <div class="kpi-icon blue"><i class="material-icons">map</i></div>
                            <span class="kpi-label">Estado</span>
                        </div>
                        <span class="kpi-value">{{ totaisEstado.nome_estado }}</span>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-header">
                            <div class="kpi-icon purple"><i class="material-icons">solar_power</i></div>
                            <span class="kpi-label">Quantidade de UCs com GD</span>
                        </div>
                        <span class="kpi-value">{{ numberWithCommas(totaisEstado.quantidade_geracao_distribuida) }}</span>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-header">
                            <div class="kpi-icon yellow"><i class="material-icons">bolt</i></div>
                            <span class="kpi-label">Potência instalada</span>
                        </div>
                        <span class="kpi-value">{{ numberWithCommas(totaisEstado.potencia_instalada) }} <small>kW</small></span>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-header">
                            <div class="kpi-icon green"><i class="material-icons">group</i></div>
                            <span class="kpi-label">População</span>
                        </div>
                        <span class="kpi-value">{{ numberWithCommas(totaisEstado.populacao) }}</span>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-header">
                            <div class="kpi-icon orange"><i class="material-icons">person</i></div>
                            <span class="kpi-label">Geração per capita</span>
                        </div>
                        <span class="kpi-value">{{ (totaisEstado.potencia_instalada/totaisEstado.populacao).toFixed(4).replace(".", ",") }} <small>kW</small></span>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-header">
                            <div class="kpi-icon red"><i class="material-icons">location_city</i></div>
                            <span class="kpi-label">Municípios</span>
                        </div>
                        <span class="kpi-value">{{ numberWithCommas(totaisEstado.quantidade_municipios) }}</span>
                    </div>
                </div>

                <div class="charts-grid">
                    <div class="chart-card">
                        <div style="width: 100%; height: 400px;" ref="graficoCidadesMaisCompetitivas" v-if="cidadesMaisCompetitivas"></div>
                    </div>
                    <div class="chart-card">
                        <div style="width: 100%; height: 400px;" ref="graficoCidadesPorMesorregiao" v-if="cidadesPorMesorregiao"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["estado_id", "totaisEstadoInit"],
        data() {
            return {
                totaisEstado: this.totaisEstadoInit,
                cidadesPorMesorregiao: null,
                cidadesMaisCompetitivas: null
            };
        },
        methods: {
            buscarCidadesPorMesorregiaoDoEstado() {
                callAPI(
                    "/estado/cidades-por-mesorregiao-do-estado/" + this.estado_id,
                    "GET",
                    null,
                    (res) => {
                        this.cidadesPorMesorregiao = res;
                        google.charts.setOnLoadCallback(this.drawChartCidadesPorMesorregiao);
                    }
                );
            },
            buscarCidadesMaisCompetitivas() {
                callAPI(
                    "/estado/cidades-mais-competitivas-do-estado/" + this.estado_id,
                    "GET",
                    null,
                    (res) => {
                        this.cidadesMaisCompetitivas = res;
                        google.charts.setOnLoadCallback(this.drawChartCidadesMaisCompetitivas);
                    }
                );
            },
            drawChartCidadesPorMesorregiao() {
                var d = [["Mesorregião", "Cidades"]];
    
                for (const mesorregiao of this.cidadesPorMesorregiao) {
                    d.push([mesorregiao.nome_mesorregiao, parseInt(mesorregiao.quantidade_cidades)]);
                }
    
                var data = google.visualization.arrayToDataTable(d);
    
                var options = {
                    title: "Municípios por mesorregião",
                    pieHole: 0.5,
                    legend: { position: "right", textStyle: { color: '#64748b' } },
                    backgroundColor: 'transparent',
                    colors: ['#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899', '#14b8a6'],
                    fontName: 'Inter',
                    titleTextStyle: { color: '#1e293b', fontSize: 16, bold: true },
                    chartArea: { width: '85%', height: '80%' }
                };
    
                var chart = new google.visualization.PieChart(this.$refs.graficoCidadesPorMesorregiao);
                chart.draw(data, options);
            },
            drawChartCidadesMaisCompetitivas() {
                var d = [["Cidade", "Competitividade"]];
                
                for (const cidade of this.cidadesMaisCompetitivas) {
                    d.push([cidade.nome_cidade, parseFloat((cidade.competitividade * 100).toFixed(2))]);
                }
    
                var data = google.visualization.arrayToDataTable(d);
    
                var options = {
                    title: "Municípios mais competitivos",
                    legend: { position: "none" },
                    backgroundColor: 'transparent',
                    colors: ['#3b82f6'],
                    fontName: 'Inter',
                    titleTextStyle: { color: '#1e293b', fontSize: 16, bold: true },
                    hAxis: { textStyle: { color: '#64748b' }, gridlines: { color: '#f1f5f9' } },
                    vAxis: { textStyle: { color: '#64748b' } },
                    chartArea: { width: '70%', height: '80%' }
                };
    
                var chart = new google.visualization.BarChart(this.$refs.graficoCidadesMaisCompetitivas);
                chart.draw(data, options);
            },
            numberWithCommas(x) {
                var parts = x.toString().replace(".", ",");

                parts = parts.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                return parts;
            },
        },
        mounted() {
            google.charts.load("current", { packages: ["corechart"] });
            
            this.buscarCidadesPorMesorregiaoDoEstado();
            this.buscarCidadesMaisCompetitivas();
        }
    };
</script>

<style scoped>
.planilha .card {
    background-color: transparent !important;
    box-shadow: none !important;
}

.kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.kpi-card {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0,0,0,0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.kpi-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.08);
}

.kpi-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 12px;
}

.kpi-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.kpi-icon i {
    font-size: 20px;
}

.kpi-icon.blue { background: #eff6ff; color: #3b82f6; }
.kpi-icon.purple { background: #f3e8ff; color: #a855f7; }
.kpi-icon.yellow { background: #fef3c7; color: #d97706; }
.kpi-icon.green { background: #dcfce7; color: #16a34a; }
.kpi-icon.orange { background: #ffedd5; color: #ea580c; }
.kpi-icon.red { background: #fee2e2; color: #ef4444; }

.kpi-label {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    color: #64748b;
    font-weight: 600;
    letter-spacing: 0.2px;
    margin-bottom: 0;
    line-height: 1.2;
}

.kpi-value {
    font-family: 'Inter', sans-serif;
    font-size: 1.6rem;
    color: #0f172a;
    font-weight: 700;
    line-height: 1.1;
    word-break: break-word;
}

.kpi-value small {
    font-size: 1rem;
    font-weight: 500;
    color: #94a3b8;
}

.charts-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    margin-top: 10px;
}
@media (min-width: 992px) {
    .charts-grid {
        grid-template-columns: 1fr 1fr;
    }
}

.chart-card {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0,0,0,0.03);
}
</style>